export default __webpack_public_path__ + "static/media/008-coffin.d851b86e.svg";